<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton icon="fa-plus" v-on:click="onClickButton" />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <ShippingDestinyTransportationList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import ShippingDestinyTransportationList from "@/components/settings/test-registers/shippingdestinytransportation/ShippingDestinyTransportationList";
import ActionButton from "@/components/button/ActionButton";

export default {
  name: "ShippingDestinyTransportationView",
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    ShippingDestinyTransportationList,
  },
  methods: {
    onClickButton(e) {
      this.$router.push({ name: "addshippingdestinytransportation" });
    },
  },
};
</script>
